<template>
    <div class="radio-wrapper" :class="{ selected: checked }" @click="stateChange" :style="{ 'margin-right': marginRight }">
        <Icon bgPosition="-275px 0" class="radio-icon" :style="{ 'margin-right': iconMargin }" />
        {{ data.label }}
    </div>
</template>

<script>
import Icon from "../icons/Icon";

export default {
    name: "Radio",
    props: ["data", "checked", "space", "beteewn"],
    components: {
        Icon
    },
    computed: {
        marginRight() {
            return this.space ? this.space + "px" : "";
        },
        iconMargin() {
            return this.beteewn != null ? this.beteewn + "px" : "";
        }
    },
    methods: {
        stateChange() {
            if (this.checked) {
                return;
            }

            this.$emit("change", this.data);
        }
    }
};
</script>

<style lang="less" scoped>
.radio-wrapper {
    position: relative;
    display: inline-block;
    margin-right: 32px;
    cursor: pointer;

    .radio-icon {
        margin-right: 8px;
        vertical-align: text-bottom;
    }

    &.selected .radio-icon {
        background-position: -275px -20px !important;
    }
}
</style>
